import { Loading } from '@cibo/profile'
import { Navigate, generatePath, useParams } from 'react-router-dom'

import { useProgramEngagementContext } from '../../features/ProgramEngagement'
import { ENGAGEMENT_ROUTES, EngagementRouteParams } from '../../navigation/types/engagementRoutes'

export const Step = () => {
  const { engagementId, stageId, stepId } = useParams<EngagementRouteParams>()
  const { basePath, engagement, program } = useProgramEngagementContext()

  const firstTaskId = engagement.data?.defaultTask({
    stepId,
    filterIds: program.data?.hiddenStepTasks(stepId),
  })?.id

  if (!stepId || engagement.isLoading || program.isLoading) {
    return <Loading />
  }
  return (
    <Navigate
      to={generatePath(`${basePath}${ENGAGEMENT_ROUTES.TASK}`, {
        engagementId,
        stageId,
        stepId,
        taskId: firstTaskId,
      })}
      replace
    />
  )
}
